export default [
  'auto',
  '16:9',
  '9:16',
  '4:3',
  '3:4',
  '1:1'
]
